import {
    NotificationTemplateForAdmin,
    NotificationTypes,
} from '@sapphicsavvy/business';
import { TemplateHash } from '../types';

export const notificationTitleHash: Record<NotificationTypes, string> = {
    [NotificationTypes.NEW_QUARTER]: 'Beginning of the Quarter',
    [NotificationTypes.PLAY_QUARTER_FIRST_REMINDER]:
        'First Reminder to Play Quarter',
    [NotificationTypes.PLAY_QUARTER_SECOND_REMINDER]:
        'Second Reminder to Play Quarter',
    [NotificationTypes.RESULTS_READY]: 'Last Quarter Results',
    [NotificationTypes.CUSTOM]: 'Custom Notification',
};

export const createNotificationTemplateHash = (
    templates: NotificationTemplateForAdmin[],
) => {
    let hash: TemplateHash = {} as TemplateHash;

    templates?.forEach((temp) => {
        hash[temp.type] = temp;
    });

    return hash;
};

export const updateTemplateHash = (
    setState: React.Dispatch<React.SetStateAction<TemplateHash | null>>,
    item: {
        type: NotificationTypes;
        fields: Partial<NotificationTemplateForAdmin>;
    },
) => {
    setState((prev) => {
        if (!prev) {
            return null;
        }

        return {
            ...prev,
            [item.type]: { ...prev[item.type], ...item.fields },
        };
    });
};
